<!-- 创建时间2023/06/29 15:17:17 -->
<!-- 创建人：Zhao bing bing -->
<!-- 组件描述： -->
<template>
  <div>
    <span v-if="$slots.default" @click="set">
      <slot></slot>
    </span>
    <template v-else>
      <yxt-button @click="set">{{ $t('pc_biz_btn_setpointmark'/** 设置关键点标记 */) }}</yxt-button>
      <span v-if="markNumber">{{ $t('pc_biz_lbl_pointnumber'/** 共标记{0}处 */, [markNumber])}}</span>
    </template>
    <form-point-drawer :kng-id="kngId" :file-id="fileId" ref="point"/>
  </div>
</template>

<script>
import { getPointList } from 'yxt-biz-pc/packages/kng-operator/service';
import formPointDrawer from './point/form-point-drawer.vue';
export default {
  components: { formPointDrawer },
  name: 'form-point',
  name_zh: '设置关键点标记',
  provide() {
    return {
      getShowAiPoints: () => this.showAiPoints
    };
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
      desc: '是否禁用',
      setter: 'BooleanSetter'
    },
    points: {
      type: Array,
      default: () => [],
      desc: '关键点数组',
      setter: 'JsonSetter'
    },
    kngId: {
      type: String,
      default: '',
      desc: '知识Id',
      setter: 'StringSetter'
    },
    fileId: {
      type: String,
      default: '',
      desc: '文件Id',
      setter: 'StringSetter'
    },
    showAiPoints: {
      type: Boolean,
      default: false,
      desc: '是否显示ai关键点（自动标记）',
      setter: 'BooleanSetter'
    }
  },
  data() {
    return {
      visible: false,
      list: []
    };
  },
  computed: {
    markNumber() {
      return this.list.length;
    }
  },
  watch: {
    list(val) {
      this.$emit('update:points', val);
    }
  },
  created() {
    this.getList();
  },
  methods: {
    async getList() {
      const res = await getPointList(this.kngId);
      this.list = res.map(item => ({markTime: item.markTime, markDesc: item.markDesc, markUrl: item.markUrl}));
    },
    set() {
      if (this.disabled) return;
      this.$refs.point.init(this.list)
        .then(res => {
          this.list = res;
        });
    }
  }
};
</script>